import React, { ReactText, useState, useMemo, useCallback } from 'react';
import { Dropdown, SearchField, SearchTree } from '@ihsm/ui-shared';
import { useActions, useAppSelector } from 'state/store';
import { useMarketDataPage } from '../../hooks';
import './MarketDataSearchTree.scss';

export const MarketDataSearchTree: React.FC = () => {
  const [filter, setFilter] = useState<string>();
  const { isSearchTreeCollapsed } = useAppSelector((state) => state.uiState);
  const { selectedAssetClass } = useAppSelector(
    (state) => state.marketDataState
  );
  const { toggleSearchTree } = useActions();
  const {
    assetClasses,
    onAssetClassChange,
    selectedAssetClassesFactor,
    factors,
  } = useMarketDataPage();

  const { setSelectedFactor } = useActions();

  const onChange = useCallback(
    (value: string) => {
      onAssetClassChange(value);
    },
    [onAssetClassChange]
  );

  const factorsList = factors.map((item, i) => ({ id: i, title: item }));

  const filteredList = useMemo(() => {
    if (filter && filter !== '') {
      const updatedList = [...factorsList].filter((listItem) => {
        const filterClean = filter?.toLowerCase().trim() || '';
        const titleClean = listItem?.title?.toLowerCase().trim();

        const titleFound = titleClean?.indexOf(filterClean) !== -1;
        return titleFound;
      });

      return updatedList;
    }

    return factorsList;
  }, [factorsList, filter]);

  const selectedElement = factorsList?.filter(
    ({ title: innerTitle }) => innerTitle === selectedAssetClassesFactor
  );

  const dropdownItems = useMemo(() => {
    return assetClasses
      ? assetClasses.map((item) => ({
          displayText: item,
          value: item,
        }))
      : [{ displayText: '', value: '' }];
  }, [assetClasses]);

  const handleSelect = (id: ReactText) => {
    const name = factorsList.filter(({ id: innerId }) => innerId === id);
    setSelectedFactor(name[0].title);
  };

  return (
    <div className="market-data-search-tree">
      <SearchTree
        header={
          <>
            <div className="market-data-search-tree__header-item">
              <Dropdown
                className="market-data-search-tree-dropdown"
                options={dropdownItems}
                onChange={onChange}
                value={selectedAssetClass}
              />
            </div>
            <div className="market-data-search-tree__header-item">
              <SearchField
                delay={1000}
                onSearch={(value) => setFilter(value)}
              />
            </div>
          </>
        }
        toggleCollapsed={toggleSearchTree}
        isCollapsed={isSearchTreeCollapsed}
        onSelect={handleSelect}
        list={filteredList}
        selectedId={selectedElement[0] ? selectedElement[0].id : 0}
      />
    </div>
  );
};
